import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMutation } from '@apollo/react-hooks';
import ResendChallengeMutation from './resendChallenge.gql';

var useResendChallengeMutation = function useResendChallengeMutation(challengeId) {
  if (!challengeId) {
    console.error("Uh oh user. Looks like you didn't get a valid challenge ID!");
  }

  var _useMutation = useMutation(ResendChallengeMutation),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      fireMutation = _useMutation2[0],
      loading = _useMutation2[1].loading;

  var resendChallengeMutation = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _result$data;

      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fireMutation({
                variables: {
                  input: {
                    challengeId: challengeId
                  }
                }
              });

            case 2:
              result = _context.sent;
              return _context.abrupt("return", result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.reinitiateChallenge);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function resendChallengeMutation() {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    resendChallengeMutation: resendChallengeMutation,
    loading: loading
  };
};

export { useResendChallengeMutation };